<template>
  <v-container fluid>
    <v-row justify="center" justify-sm="start">
      <v-col cols="10" sm="4" md="3" lg="2">
        <AddShooting />
      </v-col>
      <v-col v-for="shooting in shootings" :key="shooting.id" cols="10" sm="4" md="3" lg="2">
        <ShootingsItem :shooting="shooting" />
      </v-col>
      <v-col v-if="shootings.length === 0" cols="10" sm="6" md="7" lg="8">
        <v-card flat class="no-found-block" min-height="270px" min-width="185px">
          <p class="no-found-text">{{ $t('noShootingsFound') }}</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import ShootingsItem from '@/components/shootings/ShootingsItem.vue'
import AddShooting from '@/components/shootings/AddShooting.vue'

export default {
  name: 'ShootingsGallery',
  components: {
    AddShooting,
    ShootingsItem
  },
  computed: mapState({
    shootings: state => state.shootings
  })
}
</script>

<style lang="less" scoped>
.shootings {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 2vmin;
}

.no-result-text {
  text-align: center;
}

.no-found-block {
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-found-text {
  opacity: 0.5;
  font-size: 22px;
}
</style>
